<template>
  <div class="page_three">
    <div class="wear_left"></div>
    <div class="wear_right"></div>
    <ul>
      <li>
        <div class="txs" v-for="(item, index) in tx1" :key="index">
          <img :src="item.imgPath" alt="" />
          <div class="magnify">
            <img :src="item.imgPath" alt="" />
            <div class="detail">
              <img :src="item.type" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="txs" v-for="(item, index) in tx2" :key="index">
          <img :src="item.imgPath" alt="" />
          <div class="magnify">
            <img :src="item.imgPath" alt="" />
            <div class="detail">
              <img :src="item.type" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="txs" v-for="(item, index) in tx3" :key="index">
          <img :src="item.imgPath" alt="" />
          <div class="magnify">
            <img :src="item.imgPath" alt="" />
            <div class="detail">
              <img :src="item.type" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="txs" v-for="(item, index) in tx4" :key="index">
          <img :src="item.imgPath" alt="" />
          <div class="magnify">
            <img :src="item.imgPath" alt="" />
            <div class="detail">
              <img :src="item.type" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </li>
      <li>
        <div class="txs" v-for="(item, index) in tx5" :key="index">
          <img :src="item.imgPath" alt="" />
          <div class="magnify">
            <img :src="item.imgPath" alt="" />
            <div class="detail">
              <img :src="item.type" alt="" />
              <span>{{ item.name }}</span>
            </div>
          </div>
        </div>
      </li>
    </ul>
    <div class="btn">VIEW ALL HEROES</div>
  </div>
</template>

<script>
export default {
  name: "",
  data() {
    return {
      tx1: [
        {
          id: 1,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/1.png"),
          name: "Sticky",
        },
        {
          id: 2,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/3.png"),
          name: "Amanita",
        },
        {
          id: 3,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/10.png"),
          name: "King of Gems",
        },
        {
          id: 4,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/11.png"),
          name: "Goblin Guard",
        },
        {
          id: 5,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/12.png"),
          name: "Demon Pioneer",
        },
        {
          id: 6,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/18.png"),
          name: "Poison Challenger",
        },
        {
          id: 7,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/24.png"),
          name: "Ancient Troll",
        },
        {
          id: 8,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/27.png"),
          name: "Medussnake",
        },
        {
          id: 9,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/30.png"),
          name: "Chaos Sage",
        },
        {
          id: 10,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/38.png"),
          name: "Ice Queen",
        },
        {
          id: 11,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/39.png"),
          name: "Kung-Fu Traveler",
        },
        {
          id: 12,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/40.png"),
          name: "Poisonous Spider",
        },
      ],
      tx2: [
        {
          id: 1,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/41.png"),
          name: "Greenbeard",
        },
        {
          id: 2,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/42.png"),
          name: "Devil Eye",
        },
        {
          id: 3,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/44.png"),
          name: "The Phantom",
        },
        {
          id: 4,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/48.png"),
          name: "Prober",
        },
        {
          id: 5,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/49.png"),
          name: "Bubbly Jellyfish",
        },
        {
          id: 6,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/50.png"),
          name: "Bloody Bat",
        },
        {
          id: 7,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/51.png"),
          name: "Winter Manipulator",
        },
        {
          id: 8,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/54.png"),
          name: "Cunning Goblin",
        },
        {
          id: 9,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/55.png"),
          name: "Aunt Elementalist",
        },
        {
          id: 10,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/59.png"),
          name: "Lord of Lava",
        },
        {
          id: 11,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/60.png"),
          name: "Lord of Abyss",
        },
        {
          id: 12,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/63.png"),
          name: "Stone Spirit",
        },
      ],
      tx3: [
        {
          id: 1,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/64.png"),
          name: "Soul Stealer",
        },
        {
          id: 2,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/69.png"),
          name: "Goblin King",
        },
        {
          id: 3,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/71.png"),
          name: "Murloc Guard",
        },
        {
          id: 4,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/72.png"),
          name: "Soul Grasper",
        },
        {
          id: 5,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/73.png"),
          name: "Scythe Reaper",
        },
        {
          id: 6,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/74.png"),
          name: "Blade Master",
        },
        {
          id: 7,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/75.png"),
          name: "Fire-Face God",
        },
        {
          id: 8,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/81.png"),
          name: "Blue Dwarf",
        },
        {
          id: 9,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/82.png"),
          name: "Green Fatty",
        },
        {
          id: 10,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/89.png"),
          name: "Iron Hoof",
        },
        {
          id: 11,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/90.png"),
          name: "Old Tree",
        },
        {
          id: 12,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/96.png"),
          name: "The Punisher",
        },
      ],
      tx4: [
        {
          id: 1,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/97.png"),
          name: "Wandering Ghost",
        },
        {
          id: 2,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/98.png"),
          name: "Sugar Knight",
        },
        {
          id: 3,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/100.png"),
          name: "Shadow Wizard",
        },
        {
          id: 4,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/101.png"),
          name: "Fire Queen",
        },
        {
          id: 5,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/102.png"),
          name: "Mutant Guard",
        },
        {
          id: 6,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/103.png"),
          name: "Fighting Traveler",
        },
        {
          id: 7,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/104.png"),
          name: "Grand Summoner",
        },
        {
          id: 8,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/106.png"),
          name: "Ghost Hermit",
        },
        {
          id: 9,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/107.png"),
          name: "Mad King",
        },
        {
          id: 10,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/108.png"),
          name: "Turtle Lord",
        },
        {
          id: 11,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/110.png"),
          name: "Gargoyle",
        },
        {
          id: 12,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/117.png"),
          name: "The Voyager",
        },
      ],
      tx5: [
        {
          id: 1,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/118.png"),
          name: "Ice Girl",
        },
        {
          id: 2,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/120.png"),
          name: "The Destroyer",
        },
        {
          id: 3,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/122.png"),
          name: "Sword Emperor",
        },
        {
          id: 4,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/123.png"),
          name: "Null Shadow",
        },
        {
          id: 5,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/127.png"),
          name: "Sand Spirit",
        },
        {
          id: 6,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/128.png"),
          name: "Beginner Alchemist",
        },
        {
          id: 7,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/129.png"),
          name: "Gamble King",
        },
        {
          id: 8,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/141.png"),
          name: "The Joker",
        },
        {
          id: 9,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/144.png"),
          name: "Orochi",
        },
        {
          id: 10,
          type: require("@/assets/img/profile_photo/zhongzuICON1.png"),
          imgPath: require("@/assets/img/profile_photo/txs/147.png"),
          name: "Local Moneybags",
        },
        {
          id: 11,
          type: require("@/assets/img/profile_photo/zhongzuICON2.png"),
          imgPath: require("@/assets/img/profile_photo/txs/149.png"),
          name: "Dark Demon",
        },
        {
          id: 12,
          type: require("@/assets/img/profile_photo/zhongzuICON3.png"),
          imgPath: require("@/assets/img/profile_photo/txs/150.png"),
          name: "Puppet King",
        },
      ],
    };
  },
};
</script>
<style scoped lang="scss">
.page_three {
  width: 100%;
  height: 1179px;
  position: relative;
  .wear_left {
    z-index: 2;
    width: 342px;
    height: 1079px;
    position: absolute;
    top: 0;
    left: 0;
    background: url("~@/assets/img/side_wear1.png") repeat-y;
  }
  .wear_right {
    z-index: 2;
    width: 342px;
    height: 1079px;
    position: absolute;
    top: 0;
    right: 0;
    background: url("~@/assets/img/side_wear.png") repeat-y;
  }
  .btn {
    cursor: pointer;
    position: absolute;
    top: 827px;
    left: 5rem;
    transform: translateX(-50%);
    width: 354px;
    height: 90px;
    font-family: icomoon;
    font-size: 30px;
    font-weight: 700;
    color: #fff;
    border: 3px solid #bbbbbb;
    border-radius: 4px;
    text-align: center;
    line-height: 90px;
    // margin: 83px auto;
  }
  ul {
    width: 1561px;
    height: 706px;
    margin: 198px auto;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    position: relative;
    li {
      width: 100%;
      height: 128px;
      width: 3182px;
      display: flex;
      flex-direction: row;

      .txs {
        width: 256px;
        height: 128px;
        margin-right: 10px;
        position: relative;
        img {
          width: 256px;
          height: 128px;
        }
        .magnify {
          display: none;
        }
      }
      .txs:hover {
        .magnify {
          z-index: 2;
          width: 308px;
          height: 154px;
          display: block;
          position: relative;
          position: absolute;
          left: 128px;
          bottom: 0;
          transform: translateX(-50%);
          box-shadow: 5px 5px 5px #000;
          img {
            width: 100%;
            height: 100%;
          }
          .detail {
            position: absolute;
            bottom: 0;
            left: 0;
            width: 100%;
            height: 34px;
            background: url("~@/assets/img/profile_photo/mask.png") center
              repeat-x;
            background-size: 256px 88px;
            display: flex;
            flex-direction: row;
            img {
              margin-left: 10px;
              width: 34px;
              height: 34px;
            }
            font-size: 22px;
            font-weight: 700;
            color: #fff;
            font-family: icomoon;
            span {
              padding-left: 20px;
              line-height: 44px;
            }
          }
        }
      }
    }
    li:nth-child(1) {
      position: absolute;
      top: 26px;
      left: 0;
      animation: myfirst 30s linear 0s infinite normal;
      /* Safari 与 Chrome: */
      -webkit-animation: myfirst 30s linear 0s infinite normal;
    }
    li:nth-child(2) {
      position: absolute;
      top: 164px;
      left: -1586px;
      animation: myfirst2 28s linear 0s infinite normal;
      /* Safari 与 Chrome: */
      -webkit-animation: myfirst2 28s linear 0s infinite normal;
    }
    li:nth-child(3) {
      position: absolute;
      top: 302px;
      left: 0;
      animation: myfirst3 35s linear 0s infinite normal;
      /* Safari 与 Chrome: */
      -webkit-animation: myfirst3 35s linear 0s infinite normal;
    }
    li:nth-child(4) {
      position: absolute;
      top: 440px;
      left: -1586px;
      animation: myfirst4 23s linear 0s infinite normal;
      /* Safari 与 Chrome: */
      -webkit-animation: myfirst4 23s linear 0s infinite normal;
    }
    li:nth-child(5) {
      position: absolute;
      top: 578px;
      left: 0;
      animation: myfirst5 38s linear 0s infinite normal;
      /* Safari 与 Chrome: */
      -webkit-animation: myfirst5 38s linear 0s infinite normal;
    }
  }
}

@media (max-width: 1199px) {
  .page_three {
    // border: 1px solid red;
    width: 100vw;
    height: 11.68rem;
    position: relative;

    .wear_left {
      z-index: 2;
      width: 2.026667rem;
      height: 11.2rem;
      position: absolute;
      top: 0;
      left: 0;
      background: url("~@/assets/img/side_wear1.png") repeat-y;
      background-size: 2.026667rem 0.853333rem;
    }
    .wear_right {
      z-index: 2;
      width: 2.026667rem;
      height: 11.2rem;
      position: absolute;
      top: 0;
      right: 0;
      background: url("~@/assets/img/side_wear.png") repeat-y;
      background-size: 2.026667rem 0.853333rem;
    }
    .btn {
      cursor: pointer;
      position: absolute;
      top: 7.466667rem;
      left: 5rem;
      transform: translateX(-50%);
      width: 4.586667rem;
      height: 1.2rem;
      font-family: icomoon;
      font-size: 0.4rem;
      font-weight: 700;
      color: #fff;
      border: 0.053333rem solid #bbbbbb;
      border-radius: 4px;
      text-align: center;
      line-height: 1.2rem;
    }
    ul {
      width: 100%;
      height: 9.413333rem;
      margin: 4rem auto;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      position: relative;
      li {
        height: 1.706667rem;
        width: 28.266667rem;
        display: flex;
        flex-direction: row;

        .txs {
          width: 2.293333rem;
          height: 1.12rem;
          margin-right: 0.133333rem;
          position: relative;
          img {
            width: 2.293333rem;
            height: 1.12rem;
          }
          .magnify {
            display: none;
          }
        }
        .txs:hover {
          .magnify {
            z-index: 2;
            width: 4.106667rem;
            height: 2.053333rem;
            display: block;
            position: relative;
            position: absolute;
            left: 1.706667rem;
            bottom: 0;
            transform: translateX(-50%);
            box-shadow: 0.066667rem 0.066667rem 0.066667rem #000;
            img {
              width: 100%;
              height: 100%;
            }
            .detail {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 0.453333rem;
              background: url("~@/assets/img/profile_photo/mask.png") center
                repeat-x;
              background-size: 3.413333rem 1.173333rem;
              display: flex;
              flex-direction: row;
              img {
                margin-left: 0.133333rem;
                width: 0.453333rem;
                height: 0.453333rem;
              }
              font-size: 0.32rem;
              font-weight: 700;
              color: #fff;
              font-family: icomoon;
              span {
                padding-left: 0.266667rem;
                line-height: 0.586667rem;
              }
            }
          }
        }
      }
      li:nth-child(1) {
        position: absolute;
        top: 0.24rem;
        left: 0;
        animation: mfirst 30s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst 30s linear 0s infinite normal;
      }
      li:nth-child(2) {
        position: absolute;
        top: 1.493333rem;
        left: -21.146667rem;
        animation: mfirst2 28s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst2 28s linear 0s infinite normal;
      }
      li:nth-child(3) {
        position: absolute;
        top: 2.746667rem;
        left: 0;
        animation: mfirst3 35s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst3 35s linear 0s infinite normal;
      }
      li:nth-child(4) {
        position: absolute;
        top: 4rem;
        left: -21.146667rem;
        animation: mfirst4 23s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst4 23s linear 0s infinite normal;
      }
      li:nth-child(5) {
        position: absolute;
        top: 5.253333rem;
        left: 0;
        animation: mfirst5 38s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst5 38s linear 0s infinite normal;
      }
    }
  }
}
@media (max-width: 991px) {
  .page_three {
    // border: 1px solid red;
    width: 100vw;
    height: 11.68rem;
    position: relative;

    .wear_left {
      z-index: 2;
      width: 2.026667rem;
      height: 11.2rem;
      position: absolute;
      top: 0;
      left: 0;
      background: url("~@/assets/img/side_wear1.png") repeat-y;
      background-size: 2.026667rem 0.853333rem;
    }
    .wear_right {
      z-index: 2;
      width: 2.026667rem;
      height: 11.2rem;
      position: absolute;
      top: 0;
      right: 0;
      background: url("~@/assets/img/side_wear.png") repeat-y;
      background-size: 2.026667rem 0.853333rem;
    }
    .btn {
      cursor: pointer;
      position: absolute;
      top: 7.466667rem;
      left: 5rem;
      transform: translateX(-50%);
      width: 4.586667rem;
      height: 1.2rem;
      font-family: icomoon;
      font-size: 0.4rem;
      font-weight: 700;
      color: #fff;
      border: 0.053333rem solid #bbbbbb;
      border-radius: 4px;
      text-align: center;
      line-height: 1.2rem;
    }
    ul {
      width: 100%;
      height: 9.413333rem;
      margin: 4rem auto;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      position: relative;
      li {
        height: 1.706667rem;
        width: 28.266667rem;
        display: flex;
        flex-direction: row;

        .txs {
          width: 2.293333rem;
          height: 1.12rem;
          margin-right: 0.133333rem;
          position: relative;
          img {
            width: 2.293333rem;
            height: 1.12rem;
          }
          .magnify {
            display: none;
          }
        }
        .txs:hover {
          .magnify {
            z-index: 2;
            width: 4.106667rem;
            height: 2.053333rem;
            display: block;
            position: relative;
            position: absolute;
            left: 1.706667rem;
            bottom: 0;
            transform: translateX(-50%);
            box-shadow: 0.066667rem 0.066667rem 0.066667rem #000;
            img {
              width: 100%;
              height: 100%;
            }
            .detail {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 0.453333rem;
              background: url("~@/assets/img/profile_photo/mask.png") center
                repeat-x;
              background-size: 3.413333rem 1.173333rem;
              display: flex;
              flex-direction: row;
              img {
                margin-left: 0.133333rem;
                width: 0.453333rem;
                height: 0.453333rem;
              }
              font-size: 0.32rem;
              font-weight: 700;
              color: #fff;
              font-family: icomoon;
              span {
                padding-left: 0.266667rem;
                line-height: 0.586667rem;
              }
            }
          }
        }
      }
      li:nth-child(1) {
        position: absolute;
        top: 0.24rem;
        left: 0;
        animation: mfirst 30s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst 30s linear 0s infinite normal;
      }
      li:nth-child(2) {
        position: absolute;
        top: 1.493333rem;
        left: -21.146667rem;
        animation: mfirst2 28s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst2 28s linear 0s infinite normal;
      }
      li:nth-child(3) {
        position: absolute;
        top: 2.746667rem;
        left: 0;
        animation: mfirst3 35s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst3 35s linear 0s infinite normal;
      }
      li:nth-child(4) {
        position: absolute;
        top: 4rem;
        left: -21.146667rem;
        animation: mfirst4 23s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst4 23s linear 0s infinite normal;
      }
      li:nth-child(5) {
        position: absolute;
        top: 5.253333rem;
        left: 0;
        animation: mfirst5 38s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst5 38s linear 0s infinite normal;
      }
    }
  }
}
@media (max-width: 767px) {
  .page_three {
    // border: 1px solid red;
    width: 100vw;
    height: 11.68rem;
    position: relative;

    .wear_left {
      z-index: 2;
      width: 2.026667rem;
      height: 11.2rem;
      position: absolute;
      top: 0;
      left: 0;
      background: url("~@/assets/img/side_wear1.png") repeat-y;
      background-size: 2.026667rem 0.853333rem;
    }
    .wear_right {
      z-index: 2;
      width: 2.026667rem;
      height: 11.2rem;
      position: absolute;
      top: 0;
      right: 0;
      background: url("~@/assets/img/side_wear.png") repeat-y;
      background-size: 2.026667rem 0.853333rem;
    }
    .btn {
      cursor: pointer;
      position: absolute;
      top: 7.466667rem;
      left: 5rem;
      transform: translateX(-50%);
      width: 4.586667rem;
      height: 1.2rem;
      font-family: icomoon;
      font-size: 0.4rem;
      font-weight: 700;
      color: #fff;
      border: 0.053333rem solid #bbbbbb;
      border-radius: 4px;
      text-align: center;
      line-height: 1.2rem;
    }
    ul {
      width: 100%;
      height: 9.413333rem;
      margin: 4rem auto;
      display: flex;
      flex-direction: column;
      overflow: hidden;
      position: relative;
      li {
        height: 1.706667rem;
        width: 28.266667rem;
        display: flex;
        flex-direction: row;

        .txs {
          width: 2.293333rem;
          height: 1.12rem;
          margin-right: 0.133333rem;
          position: relative;
          img {
            width: 2.293333rem;
            height: 1.12rem;
          }
          .magnify {
            display: none;
          }
        }
        .txs:hover {
          .magnify {
            z-index: 2;
            width: 4.106667rem;
            height: 2.053333rem;
            display: block;
            position: relative;
            position: absolute;
            left: 1.706667rem;
            bottom: 0;
            transform: translateX(-50%);
            box-shadow: 0.066667rem 0.066667rem 0.066667rem #000;
            img {
              width: 100%;
              height: 100%;
            }
            .detail {
              position: absolute;
              bottom: 0;
              left: 0;
              width: 100%;
              height: 0.453333rem;
              background: url("~@/assets/img/profile_photo/mask.png") center
                repeat-x;
              background-size: 3.413333rem 1.173333rem;
              display: flex;
              flex-direction: row;
              img {
                margin-left: 0.133333rem;
                width: 0.453333rem;
                height: 0.453333rem;
              }
              font-size: 0.32rem;
              font-weight: 700;
              color: #fff;
              font-family: icomoon;
              span {
                padding-left: 0.266667rem;
                line-height: 0.586667rem;
              }
            }
          }
        }
      }
      li:nth-child(1) {
        position: absolute;
        top: 0.24rem;
        left: 0;
        animation: mfirst 30s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst 30s linear 0s infinite normal;
      }
      li:nth-child(2) {
        position: absolute;
        top: 1.493333rem;
        left: -21.146667rem;
        animation: mfirst2 28s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst2 28s linear 0s infinite normal;
      }
      li:nth-child(3) {
        position: absolute;
        top: 2.746667rem;
        left: 0;
        animation: mfirst3 35s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst3 35s linear 0s infinite normal;
      }
      li:nth-child(4) {
        position: absolute;
        top: 4rem;
        left: -21.146667rem;
        animation: mfirst4 23s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst4 23s linear 0s infinite normal;
      }
      li:nth-child(5) {
        position: absolute;
        top: 5.253333rem;
        left: 0;
        animation: mfirst5 38s linear 0s infinite normal;
        /* Safari 与 Chrome: */
        -webkit-animation: mfirst5 38s linear 0s infinite normal;
      }
    }
  }
}

@keyframes myfirst {
  from {
    left: 0;
  }
  to {
    left: -1586px;
  }
}

@-webkit-keyframes myfirst /* Safari 与 Chrome */ {
  from {
    left: 0;
  }
  to {
    left: -1586px;
  }
}
@keyframes myfirst2 {
  from {
    left: -1586px;
  }
  to {
    left: 0;
  }
}

@-webkit-keyframes myfirst2 /* Safari 与 Chrome */ {
  from {
    left: -1586px;
  }
  to {
    left: 0;
  }
}
@keyframes myfirst3 {
  from {
    left: 0;
  }
  to {
    left: -1586px;
  }
}

@-webkit-keyframes myfirst3 /* Safari 与 Chrome */ {
  from {
    left: 0;
  }
  to {
    left: -1586px;
  }
}
@keyframes myfirst4 {
  from {
    left: -1586px;
  }
  to {
    left: 0;
  }
}

@-webkit-keyframes myfirst4 /* Safari 与 Chrome */ {
  from {
    left: -1586px;
  }
  to {
    left: 0;
  }
}
@keyframes myfirst5 {
  from {
    left: 0;
  }
  to {
    left: -1536px;
  }
}

@-webkit-keyframes myfirst5 /* Safari 与 Chrome */ {
  from {
    left: 0;
  }
  to {
    left: -1536px;
  }
}

// 移动端动画

@keyframes mfirst {
  from {
    left: 0;
  }
  to {
    left: -21.146667rem;
  }
}

@-webkit-keyframes mfirst /* Safari 与 Chrome */ {
  from {
    left: 0;
  }
  to {
    left: -21.146667rem;
  }
}
@keyframes mfirst2 {
  from {
    left: -21.146667rem;
  }
  to {
    left: 0;
  }
}

@-webkit-keyframes mfirst2 /* Safari 与 Chrome */ {
  from {
    left: -21.146667rem;
  }
  to {
    left: 0;
  }
}
@keyframes mfirst3 {
  from {
    left: 0;
  }
  to {
    left: -21.146667rem;
  }
}

@-webkit-keyframes mfirst3 /* Safari 与 Chrome */ {
  from {
    left: 0;
  }
  to {
    left: -21.146667rem;
  }
}
@keyframes mfirst4 {
  from {
    left: -21.146667rem;
  }
  to {
    left: 0;
  }
}

@-webkit-keyframes mfirst4 /* Safari 与 Chrome */ {
  from {
    left: -21.146667rem;
  }
  to {
    left: 0;
  }
}
@keyframes mfirst5 {
  from {
    left: 0;
  }
  to {
    left: -21.146667rem;
  }
}

@-webkit-keyframes mfirst5 /* Safari 与 Chrome */ {
  from {
    left: 0;
  }
  to {
    left: -21.146667rem;
  }
}
</style>
